import { AuthenticatedRoute } from 'module/authentication/components/secure-route';

export const SecureRoute = (props) => {
  return <AuthenticatedRoute {...props} loginUrl="/login" />;
};
